<app-agent-header [activeStep]="2" mobileTitle="Test taker details" [showAgentBadge]="true"></app-agent-header>
<main class="main-container">
  <div class="tt-email-wrapper">
    <section class="back-link-section">
      <a class="d-inline-flex gap-8 align-items-center pointer text-decoration-none" (click)="goBack()" title="Back">
        <span><img src="/assets/images/chevron-arrow-left-blue.svg" alt="chevron-arrow" class="chevronArrow object-fit-contain"></span>
        <span class="txt-baseBlue600 text-base lh-24 font-medium">Back</span>
      </a>
    </section>
    <section class="tt-email-card-wrapper">
      <div class="card-panel">
      <div class="tt-email-card">
        <div class="card-intro">
          <div class="card-icon">
            <img src="/assets/images/rp-tt-icon-withbg.svg" alt="test taker email" class="d-none d-lg-block">
            <img src="/assets/images/Icon-duotone.svg" alt="test taker email" class="d-block d-lg-none">
          </div>
          <div class="card-heading">
            <h2 class="card-title">Test taker details</h2>
            <p class="card-description">Enter the test taker's details to continue with the booking.</p>
          </div>
        </div>
        <form class="tt-email-form" [formGroup]="ttEmailForm">
          <div class="form-fields">
            <div class="field-group">
              <app-custom-bx-input id="ttEmail" type="text" placeholder="Enter email address"
                [control]="ttEmailForm.get('email')" [firstErrorOnly]="true"
                [customErrorMessage]="emailErrorMessages"
              (focusOut)="onEmailBlur()"></app-custom-bx-input>
            </div>
            <div class="field-group">
              <app-custom-bx-input id="ttDob" type="date" placeholder="DD/MM/YYYY"
              [control]="ttEmailForm.get('dob')" [firstErrorOnly]="true"></app-custom-bx-input>
            </div>
          </div>
          @if (errorMessage) {
            <div class="error-field">
              <img width="16" height="16" src="/assets/images/danger.svg" alt="error">
              <span>{{ errorMessage }}</span>
            </div>
          }
        </form>
      </div>
      <div class="consent-section" [ngClass]="{'consent-checked': consentChecked}" (click)="toggleConsent()">
        <div class="consent-checkbox">
          @if (consentChecked) {
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <rect width="20" height="20" rx="4" fill="#15803D"/>
              <path d="M5 10L8.5 13.5L15 7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          }
          @if (!consentChecked) {
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <rect x="0.5" y="0.5" width="19" height="19" rx="3.5" fill="white" stroke="#878787"/>
            </svg>
          }
        </div>
        <p class="consent-text">As an IDP agent, I acknowledge that I am not permitted to book this test until I have received the test taker’s authorisation and consent to use their personal information.</p>
      </div>
      </div>
      <button class="proceed-btn"
        [disabled]="ttEmailForm.invalid || !consentChecked"
        [ngClass]="ttEmailForm.invalid || !consentChecked ? 'btn-disabled' : ''"
      (click)="onProceed()">Continue booking</button>
    </section>
  </div>
</main>
<!-- User Not Found Popup -->
@if (showUserNotFoundPopup) {
  <div class="popup-overlay">
    <div class="popup-wrapper d-flex flex-column">
      <a class="mob-close d-flex d-lg-none justify-content-end" (click)="onCancelPopup()">
        <img src="/assets/images/close-white.svg" alt="close-icon">
      </a>
      <div class="popup-inner-wrapper d-flex flex-column">
        <div class="popup-images d-flex align-items-center justify-content-between">
          <img class="popup-img" src="/assets/images/rp-tt-icon-withbg.svg" alt="user not found">
          <a class="close d-none d-lg-flex" (click)="onCancelPopup()">
            <img src="/assets/images/close.svg" alt="close-icon">
          </a>
        </div>
        <div class="popup-inner-content d-flex flex-column">
          <h2 class="popup-heading">Test taker account not found</h2>
          <div class="popup-paragraphs d-flex flex-column open-sans">
          We couldn't find an existing account for this test taker. To continue with the booking, create a new account.
          </div>
        </div>
        <div class="popup-buttons d-flex flex-column flex-lg-row align-items-center">
          <button class="popup-secondary-btn" (click)="onCancelPopup()">Back</button>
          <button class="popup-primary-btn text-center" (click)="onCreateUser()">Create account</button>
        </div>
      </div>
    </div>
  </div>
}
<footer class="mobile-footer d-flex d-lg-none align-items-center justify-content-between">
  <a class="d-inline-flex gap-8 align-items-center pointer text-decoration-none" (click)="goBack()" title="Back">
    <span><img src="/assets/images/chevron-arrow-left-blue.svg" alt="chevron-arrow" class="chevronArrow object-fit-contain"></span>
    <span class="txt-baseBlue600 text-base lh-24 font-medium">Back</span>
  </a>
  <button class="mobile-proceed-btn"
    [disabled]="ttEmailForm.invalid || !consentChecked"
    [ngClass]="ttEmailForm.invalid || !consentChecked ? 'btn-disabled' : ''"
  (click)="onProceed()">Continue booking</button>
</footer>
